module.exports = {"TXTWCL_Extra_time___N0":{"id":"TXTWCL_Extra_time___N0","defaultMessage":"Prórroga - {0}"}}